import ApiUtils from '@shared/utils/api';
import DeviceConfig from '@devices/config';
import FlavourConfig from '../../../../shared/config/flavours';
import Focus from '../../../../shared/types/enums/focus';
import Pages from '../../../../shared/types/enums/pages';
import TAccess from '../../templates/access';
import TranslationManager from '../../../../shared/assets/locale/translationsManager';
import initAnonymous from '../../../../shared/actions/login/initAnonymous';
import { pushRoute } from '../../../../shared/store/thunks/route.thunk';
import { setFocus } from '../../../../shared/store/slices/focus.slice';
import { useAppDispatch } from '../../../../shared/store/hooks';
import { useEffect, useMemo } from 'react';
import { removeInitialized } from '../../../../shared/store/slices/user.slice';

export default function Link() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(removeInitialized());
  }, []);

  const { buttonText, description, idDevice, qrUrl, title } = useMemo(() => {
    const buttonText = FlavourConfig.capabilities.anonymous
      ? TranslationManager.get('PAGES.ACCESS.LINK.BUTTON')
      : null;
    const description = TranslationManager.get(
      'PAGES.ACCESS.LINK.DESCRIPTION',
      ApiUtils.getUrl('activate_link')
    );
    const idDevice = FlavourConfig.capabilities.uuidLink
      ? DeviceConfig.info.uuid
      : undefined;
    const qrUrl = ApiUtils.getUrl('activate_link');
    const title = TranslationManager.get('PAGES.ACCESS.LINK.TITLE');
    return { buttonText, description, idDevice, qrUrl, title };
  }, []);

  const action = () => {
    if (FlavourConfig.capabilities.anonymous) {
      initAnonymous();
      dispatch(setFocus(Focus.MENU));
    }
  };

  const returnAction = () => {
    if (FlavourConfig.languages.length > 1) {
      dispatch(
        pushRoute({ route: { Page: Pages.LANGUAGES, overwrite: true } })
      );
    } else {
      dispatch(pushRoute({ route: { Page: Pages.WELCOME, overwrite: true } }));
    }
  };

  return (
    <TAccess
      action={action}
      buttonText={buttonText}
      description={description}
      idDevice={idDevice}
      qrUrl={qrUrl}
      returnAction={returnAction}
      title={title}
    />
  );
}
